import React, { useState, useEffect } from "react";
import { EpreuvesList2 } from "../EpreuvesList2";
import { loadEpreuves } from "../requests";

export const QueryTriathlon = ({ regionFilter, yearFilter }) => {
  const [epreuves, setEpreuves] = useState([]);

  const fetchData = async () => {
    try {
      const epreuvesResult = await loadEpreuves(
        regionFilter,
        "",
        0,
        yearFilter,
        ["Jeunes", "XXS", "XS", "S", "M", "L", "XL", "XXL"],
        "",
        0,
        25000,
        ["Piscine", "Lac", "Mer", "Rivière", "Plan d'eau", "0"],
        ["1", "0"]
      );
      setEpreuves(epreuvesResult);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [regionFilter]);

  return (
    <div className="container visible-md">
      <div className="row my-2 font-weight-bold">
        <h5 className="font-weight-bold">{epreuves.length} triathlons</h5>
      </div>
      <div className="row">
        <EpreuvesList2 epreuves={epreuves} filterByRegion={regionFilter} />
      </div>
    </div>
  );
};
